import { SVG, SVGProps } from './svg'

export function IconPublish(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M20 7a2 2 0 012 2v9a2 2 0 01-2 2H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2h1.2c.5 0 1-.2 1.4-.6L8 5a3 3 0 012.1-.9h3.6a3 3 0 012 .9l1.6 1.5c.4.4.9.6 1.4.6H20zM8 13a4 4 0 108 0 4 4 0 00-8 0z" />
    </SVG>
  )
}
